import { useOrderDetails } from "../blocks/Cart/useOrderDetails";
import { useAuth } from "../stores/hooks/useAuth";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";

export const usePackageEditorSetting = (): boolean => {
  const { isOrder } = useOrderDetails();
  const dealer = useNullableDealerAccountInfo();
  const [token] = useAuth();

  const packageEditorIsEnabled: boolean =
    String(dealer?.dealerHidePackageEditor) === "0";

  const isAdmin: boolean = String(token.userRoleId) === "1";

  const dealerPackageEditorAdminOnly: boolean =
    String(dealer?.dealerPackageEditorAdminOnly) === "1";

  if (dealerPackageEditorAdminOnly && !isAdmin) {
    return false;
  }

  return packageEditorIsEnabled && !isOrder;
};
